import request from "../service/request"

const ADD = {}
const CLEAR = {}

export {ADD, CLEAR}

const add = (bucketName, locale, data) => {
  return {
    type: ADD,
    bucketName,
    locale,
    data
  }
}

export const clear = () => {
  return {
    type: CLEAR
  }
}

export const get = (buckets, rawLocale = "", forceUpdate = false) => {
  return (dispatch, getState) => {
    const locale = rawLocale.toLowerCase()
    const {currentLocale} = getState().lang
    if (currentLocale !== locale) {
      dispatch(clear())
    }

    return Promise.all(buckets.map((bucketName) => getBucket({dispatch, getState}, {bucketName, locale, forceUpdate})))
  }
}

export default {
  get,
  clear
}

function getBucket({dispatch, getState}, {bucketName, locale, forceUpdate}) {
  const {lang} = getState()
  const load = () => {
    return request(bucketName, locale).then((data) => {
      dispatch(add(bucketName, locale, {...bucket, ...data}))
    })
  }

  let bucket = lang[bucketName]
  if (!bucket) {
    bucket = {}
    bucket.load = load()
  }

  if (forceUpdate) {
    bucket.load = load()
  }

  dispatch(add(bucketName, locale, bucket))
  return bucket.load
}
